import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IEditPayload {
    id: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IListState {
    status: string
    data: any
    suggested: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    suggested: null,
    errors: null
}

const editSlice = createSlice({
    name: 'hub/rfqs/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditPayload>) {
            state.status = STATUS.RUNNING
        },
        onRequestClear(state, action: PayloadAction<IEditPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuggested(state, action) {
            state.suggested = action.payload
        },
        onClear(state, action) {
            state.suggested = null
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
            state.suggested = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editActions = editSlice.actions
export default editSlice.reducer
